// Exact-match map: execution_result.reason (system-withdrawal) -> user copy.
// Keys are hardcoded literals emitted by the backend; if a call site's
// literal changes, the mapping silently degrades to the fallback. Emitting
// call sites:
//   apps/actions/callbacks/proposal_action_sync.py
//   apps/actions/tasks/__init__.py (legacy calendar task)
//   apps/actions/management/commands/mass_withdraw_proposals.py
//   apps/actions/services/invalid_proposal_sweep.py
const WITHDRAWAL_REASON_COPY: Record<string, string> = {
  'Superseded by sent email on same thread':
    "You'd already replied on this thread, so we stood down.",
  'Meeting created with overlapping attendees':
    'A meeting with these attendees was already booked.',
  'Calendar event time has passed': 'The proposed time has already passed.',
  'Duplicate proposal withdrawn - keeping oldest by ID':
    'A duplicate of this was already in your list.',
  'We withdrew this suggestion because it can no longer be carried out – the record or access it relied on has changed.':
    'The record or access this relied on has changed, so it can no longer be carried out.',
};

export const WITHDRAWAL_FALLBACK_COPY = 'No longer needed.';

function extractWithdrawalReason(executionResult: unknown): string | null {
  if (
    executionResult !== null &&
    typeof executionResult === 'object' &&
    'reason' in executionResult
  ) {
    const { reason } = executionResult as { reason?: unknown };
    return typeof reason === 'string' ? reason : null;
  }
  return null;
}

export function getWithdrawalExplanation(executionResult: unknown): string {
  const reason = extractWithdrawalReason(executionResult);
  const mapped = reason ? WITHDRAWAL_REASON_COPY[reason] : undefined;
  if (typeof mapped === 'string') {
    return mapped;
  }
  if (reason !== null && reason.trim() !== '') {
    return reason;
  }
  return WITHDRAWAL_FALLBACK_COPY;
}
